import { createFileRoute } from '@tanstack/react-router';

/**
 * Event Alerts Route
 *
 * Supports optional search parameters:
 * - msid: miEdge System ID to open specific alert tab
 *
 * Authentication is handled by the parent _protected layout route.
 */
export const Route = createFileRoute('/_protected/$module/event_alerts')({
  // No beforeLoad - parent _protected handles auth
});
